import React, { Component } from 'react';

/* 개발담당:양유빈
 * 화면기능:도매, 소매 사업장 사진 공통
 * 세부설명:
*/

export class ComPhoto extends Component {
    static displayName = ComPhoto.name;

    constructor(props) {
        super(props);
        this.state = {
        };
    }
    //초기화
    componentDidMount() {
      
    }
    
    render() {
        let className = "";
        let Photo = "";
        if (this.props.className !== undefined && this.props.className !== null) {
            className = this.props.className;
        }
        if (this.props.Photo !== undefined && this.props.Photo !== null) {
            Photo = this.props.Photo;
        }

        if (Photo !== "") {
            return (
                <>
                    <div className={className} style={{ backgroundImage: `url(${Photo})` }}></div>
                </>
            );
        }
        else {
            return (
                <>
                    <div className={className}></div>
                </>
            );
        }
        
    }
}
